module.exports = __webpack_public_path__ + "img/VIP_bg.d86ca390.jpg";